/**
 * @file：意见反馈 request
 */
import {
  IFeedbackPicVO,
  IFeedbackQuestion,
  IFeedbackQuestionTransform
} from '@/schemas/feedback';
import { request } from './request';
import { ApiConfigs, Response } from '../schemas/service';

const api: ApiConfigs = {
  uploadFeedbackPics: {
    url: '/health/api/v1/home/feedbackPicUpload',
    method: 'POST'
  },
  saveFeedback: {
    url: '/health/api/v1/home/saveFeedback',
    method: 'POST'
  },
  queryCommonProblems: {
    url: '/health/api/v1/home/commonProblems',
    method: 'GET'
  }
};

const feedback = {
  async uploadFeedbackPics(base64s) {
    try {
      const response: Response<IFeedbackPicVO[] | null> = await request(
        api.uploadFeedbackPics,
        undefined,
        {
          base64s
        },
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async saveFeedback(params) {
    try {
      const response: Response<boolean> = await request(
        api.saveFeedback,
        undefined,
        params,
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;
      if (result != null) {
        return result;
      }
      return Promise.reject();
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async getCommonProblems() {
    try {
      const response: Response<IFeedbackQuestion[] | null> = await request(
        api.queryCommonProblems,
        undefined,
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;
      if (result) {
        const feedbackQuestionTabs: IFeedbackQuestionTransform[] = result.map(
          (item, index) => ({
            key: index,
            value: item.tabName,
            questionList: item.list
          })
        );
        return feedbackQuestionTabs;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default feedback;
